import { useNavigate } from 'react-router-dom';
import SubPageHero from '@/components/SubPageHero';
import { AS_FLOW, asLabel, asDesc, asIcon } from './asMeta';
import s from './As.module.scss';

/**
 * [2026-09-12] A/S 허브(공개) — 고객지원 > A/S 신청·현황. 로그인 불필요(안내·절차).
 *   구성: 절차 안내(화면 B, 8단계) + 안전/환경 차이 설명 + [A/S 신청]/[내 A/S 현황] 진입.
 *   신청/현황 자체는 로그인 필요(정식회원) — 이 허브는 비회원도 A/S를 이해하고 진입하도록.
 */
function StepSvg({ d, size = 30 }: { d: string; size?: number }) {
	return <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>;
}

export default function AsCenter() {
	const nav = useNavigate();
	return (
		<>
			<SubPageHero title="A/S 신청·현황" subtitle="사후관리 · 접수부터 완료까지 진행상황을 추적합니다"
				image="/images/auth/member-hero.jpg" crumbs={[{ label: 'HOME' }, { label: '고객지원' }, { label: 'A/S' }]} />
			<div className={s.wrap}>
				<p className={s.eyebrow}>A/S SERVICE</p>
				<h2 className={s.h2}>A/S <b>신청·현황</b></h2>
				<p className={s.lead}>제품 고장·점검을 신청하시면 <b>접수 → 진단 → 처리 → 완료</b> 단계로 진행상황을 택배 배송조회처럼 실시간 안내합니다.</p>

				<div className={s.ctaRow}>
					<button className={s.ctaPrimary} onClick={() => nav('/support/as/apply')}>A/S 신청하기</button>
					<button className={s.ctaGhost} onClick={() => nav('/support/my-as')}>내 A/S 현황 보기</button>
				</div>

				{/* 절차 안내(화면 B) */}
				<div className={s.centerSec}>
					<h3 className={s.h3}>A/S는 이렇게 진행됩니다</h3>
					<p className={s.subLead}>접수부터 완료까지 8단계로 처리하며, 각 단계는 A/S 현황에서 실시간 확인할 수 있습니다.</p>
					<div className={s.flow}>
						{AS_FLOW.map((st, i) => (
							<div className={s.flowStep} key={st}>
								<div className={s.flowIco}><StepSvg d={asIcon(st)} /></div>
								<div className={s.flowNo}>{i + 1}</div>
								<div className={s.flowLabel}>{asLabel(st)}</div>
								<div className={s.flowDesc}>{asDesc(st)}</div>
							</div>
						))}
					</div>
				</div>

				{/* 안전/환경 차이 */}
				<div className={s.centerSec}>
					<h3 className={s.h3}>안전 · 환경, 제품에 맞춘 A/S</h3>
					<div className={s.domainCards}>
						<div className={s.domainCard}>
							<span className={`${s.badge} ${s.bSafety}`}>안전</span>
							<div className={s.dcTitle}>휴대형 제품 · 입고 수리</div>
							<p className={s.dcDesc}>체감온도계(WBGT) 등 휴대형 계측기는 제품을 <b>입고</b>받아 수리·<b>교정·검증</b> 후 출고합니다.
								측정 정확도 교정이 핵심입니다.</p>
						</div>
						<div className={s.domainCard}>
							<span className={`${s.badge} ${s.bEnv}`}>환경</span>
							<div className={s.dcTitle}>설치형 제품 · 현장 출동</div>
							<p className={s.dcDesc}>대기배출 IoT Gateway 등 설치형은 담당 기사가 <b>현장으로 출동</b>해 진단·부품교체·배선/설정을 처리하고
								통신·측정 <b>정상화를 검증</b>합니다.</p>
						</div>
					</div>
				</div>

				<div className={s.centerNote}>
					A/S 신청은 정식회원(휴대폰 본인인증) 로그인이 필요합니다. 접수 후 진행상황은 <b>내 A/S 현황</b>에서 확인하세요.
					긴급 문의는 실시간 상담(전화·카카오톡)을 이용해 주세요.
				</div>
			</div>
		</>
	);
}
